module.exports = __webpack_public_path__ + "img/phone-arrow-up-right.574a6922.svg";